/*
*  Show price
* @param {object} row
* @param {boolean} reissueAndRedeemVoucher
* @param {boolean} valid
* @param {number} sn
* @param {function} setShowModal
* @param {boolean} redeemVoucher
* @returns {JSX.Element}
*
 */
import {Button} from "@mui/material";
import * as React from "react";

export default function RedeemVoucherSubmit ({row, reissueAndRedeemVoucher,setValid, valid, sn, setOpen, setShowModal, redeemVoucher}) {

    // if (row.is_redeemed > 0) return (
    //     <>
    //         <Button variant={"contained"} sx={{m: 1}}
    //                 onClick={() => reissueAndRedeemVoucher()}
    //                 disabled={!valid}
    //         >Re-issue new voucher and redeem voucher #{sn} again</Button>
    //         <Button onClick={() => setShowModal(false)}>Cancel</Button>
    //     </>
    // );

    return (
        <>
            <Button variant={"contained"} sx={{m: 1}}
                    onClick={() => redeemVoucher()}
                    disabled={!valid}
            >Submit</Button>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
        </>
    )
}
